import _this from './../../../../main';

export const getColumns = (res) => {
  console.log(res)
  let data = res.data.data.service_info.list_show_header_pc;
  let columns = [];
  columns = data.map((item, index) => {
    return {
      title: item.label,
      dataIndex: item.flag,
    };
  });
  let obj1 = {
    title: '序号',
    width: '65px',
    customRender: (text, record, index) => index + 1,
  };
  let arr = [
    // {
    //   title: '提交时间',
    //   dataIndex: 'task_submit_time'
    // },
    {
      title: '开始时间',
      width: '180px',
      dataIndex: 'task_start_time'
    },
    // {
    //   title: '结束时间',
    //   dataIndex: 'task_end_time'
    // },
    // {
    //   title: '医院名称',
    //   dataIndex: 'task_hospital_name'
    // },
    // {
    //   title: '医生姓名',
    //   dataIndex: 'task_doctor_name'
    // },
    {
      title: '使用资料',
      width: '300px',
      dataIndex: 'task_docment_name',
      scopedSlots: { customRender: 'task_docment_name' },
    },
    {
      title: '签到地址',
      dataIndex: 'sign_address',
      width: '400px',
      scopedSlots: { customRender: 'sign_address' },
    },
    {
      title: '报告状态',
      dataIndex: 'status',
      width: '120px',
      scopedSlots: { customRender: 'status' },
    },
    {
      title: '操作',
      dataIndex: 'operation',
      scopedSlots: { customRender: 'operation' },
    },
  ];
  columns = [obj1, ...columns, ...arr];
  return columns;
};

export const getReportTableData = (res) => {
  let data = res.data.data.workReportList;
  let totalData = [];

  data.forEach((column, index) => {
    let tableData = [];
    column.workReport.forEach((list, index) => {
      const cl = {
        status: list.status,
        id: list.id,
        promoter: column.promoter_id,
        task_submit_time: _this.$Format(list.create_time),
        task_start_time: list.workReportDetail.report_value.start_time,
        task_end_time: list.workReportDetail.report_value.end_time,
        task_hospital_name: list.hospital == null ? '' : list.hospital.name,
        task_doctor_name: list.doctor == null ? '' : list.doctor.user_realname,
        task_docment_name: list.map_id.map_id_info.name,
        sign_address: list.workReportDetail.report_value.sign_address ? list.workReportDetail.report_value.sign_address : '-',
      };
      const { list_show_items_pc, id } = list;
      if (list_show_items_pc) {
        list_show_items_pc.forEach(((item) => {
          cl[item.flag] = item.show;
          cl.id = id;
          cl.sourceData = list_show_items_pc || [];
        }));
        tableData.push(cl);
      } else {
        tableData = [];
      }
    });
    totalData.push(tableData);
  });
  return totalData;
};